module.exports = __webpack_public_path__ + "img/alarmBack.27f8cc9b.png";